import { lazy } from 'react';

// project imports
import Loadable from 'ui-component/Loadable';
import MinimalLayout from 'layout/MinimalLayout';

// login option 3 routing
const LoginPage = Loadable(lazy(() => import('views/pages/authentication/LoginPage')));

// ==============================|| AUTHENTICATION ROUTING ||============================== //

const AuthenticationRoutes = {
    path: '/',
    element: <MinimalLayout />,
    children: [
        {
            path: '/',
            element: <LoginPage />
        },
        {
            path: '/login',
            element: <LoginPage />
        }
    ]
};

export default AuthenticationRoutes;
